export var SelectionModes;
(function (SelectionModes) {
    SelectionModes["Lens"] = "Lens";
    SelectionModes["Click"] = "Click";
})(SelectionModes || (SelectionModes = {}));
